import { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import {fetchData,getTranslatedValue,toasterrormsg} from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget24,
} from '../../../_metronic/partials/widgets'
import Swal from 'sweetalert2'
import { TourPackageDetailsHeader } from './TourPackageDetailsHeader'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewToursList: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
      if (categoryId != '5') {
        navigate('../dashboard/');
      }
    }, [categoryId])
  const location = useLocation();
  const editTourpackageId = (location.state as any)?.tourpackageId || '';

  // -------- state start ------------ 
  const [tourPackageDetail, setTourPackageDetail] = useState([]);
  const [primLanguage, setPrimLanguage] = useState("");
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayTourList, setDisplayTourList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  // ----------- state end ------------

  // ----------------------- functions ---------------------------- 
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = tourPackageDetail.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = tourPackageDetail.slice(tmp, tolimi)
      setDisplayTourList(tmpdata)
    }
  }

  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const tourPackageDetailsApiCall = async () => {
    var param: any = {
      tourpackageId: editTourpackageId,
    }
    var response: any = await fetchData("public/tourpackageDetails", param)

    if (response.status == "200") {
      var tourList = response.data[0]['toursDetail'];
      setTourPackageDetail(tourList);
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = tourList.slice(offset, offset + limit);
      setDisplayTourList(tmp)
      var totpag = (Math.ceil(tourList.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = tourList.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = tourList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    }
    else {
      toasterrormsg(response.message)
    }
  }
  //   delete hotel api call
  const confirmdelete = (toursId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'toursId': toursId
        }
        var res = await fetchData("public/deleteTours", param)

        if (res.status == "200") {
          tourPackageDetailsApiCall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }
  useEffect(() => {
    tourPackageDetailsApiCall();
  }, [editTourpackageId])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Tours')}</PageTitle>
      <ToastContainer />
      <TourPackageDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {
          displayTourList.map((tour: any, index: any) => {
            var description = getTranslatedValue(lang, tour, '_highlight',primLanguage);
            var tourName = getTranslatedValue(lang, tour, '_name', primLanguage);
            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget24
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  toursId={tour['toursId']}
                  deleteTours={confirmdelete}
                  tourName={tourName}
                  image={(tour['images'].length != 0) ? tour['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                  description={description}
                  maxPeople={tour['maxPeople']}
                  progress='100%'
                />
              </div>
            )
          })
        }
      </div>
      {
        tourPackageDetail.length != 0 ? (
          <>
            <div className='d-flex flex-stack flex-wrap pt-10'>
              <div className='fs-6 fw-bold text-gray-700'>Showing {from} to {to} of {tourPackageDetail.length} entries</div>

              <ul className='pagination'>

                <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                  <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                    <i className='previous'></i>
                  </span>
                </li>
                {pageNumbersList.map((item: any) => {
                  return (
                    <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`}>
                      <span className='page-link' onClick={() => onpagecahnge(item)}>
                        {item}
                      </span>
                    </li>
                  )
                })}

                <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                  <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                    <i className='next'></i>
                  </span>
                </li>
              </ul>
            </div>
          </>
        ) : ('')
      }
      {/* end::Row */}
    </>
  )
}

export { ViewToursList }
